<i18n src='../../static/localization/map.json'></i18n>
<template>
  <div class="mapComponent">
    <analytics v-bind:class="{ show: !showAnalytics }"></analytics>
    <nav class="navbar ">
      <div class="navbar-brand">
        <a class="navbar-item">
          <img src="https://staticcontentskymaps.blob.core.windows.net/static/static/logo_v2.png" alt="Skymaps">
        </a>
        <div class="navbar-burger burger" data-target="navMenubd-example">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <div id="navMenubd-example" class="navbar-menu">
        <div class="navbar-start"></div>
        <div class="navbar-end">
          <router-link class="navbar-item" to="/">
            <a>{{ $t('navbar.projects') }}</a>
          </router-link>
          <div class="navbar-item has-dropdown is-hoverable userProfile">
            <a class="navbar-link">
              <span class="icon user" style="color: #333;">{{userName}}
                <i class="fa fa-user"></i>
              </span>
            </a>
            <div class="navbar-dropdown">
              <router-link to="/logout">
                <a class="navbar-item logout">{{ $t('navbar.logout') }}</a>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </nav>



    <div class="map" id="map"></div>

    <div id="sidebar">
      <nav class="panel mainpanel" v-bind:class="{ active: isActive }">
        <a href="/">
          <span class="icon menuicon is-medium">
            <i class="fa fa-home"></i>
          </span>
        </a>
        <span class="icon menuicon" v-on:click="isActive=!isActive;showHide()">
          <div class="layers"></div>
        </span>
        <span class="icon menuicon is-medium charticon" v-if="sensors.length>0" v-on:click="showAnalytics=!showAnalytics">
          <i class="fa fa-bar-chart" aria-hidden="true"></i>
        </span>  
        <span class="icon menuicon is-medium charticon" v-if="docs.length>0" v-on:click="showAnalytics=!showAnalytics">
          <i class="fa fa-file" aria-hidden="true"></i>
        </span>
      </nav>
      <nav class="panel layerpanel" v-bind:class="{ active: !isActive }">
        <div class="toggleLayerPanel" v-on:click="isActive=!isActive">
          <span class="is-small">
            <i class="fa fa-angle-double-left" aria-hidden="true"></i>
          </span>
          <p>{{ $t('leftPanel.back') }}</p>
        </div>
        <!-- <div class="tools"> -->
          <!-- <span class="icon is-medium" v-on:click="mapOnClick(addMarkerToMap)">
            <img src="../../static/img/marker.svg" alt="map-marker">
          </span> -->
          <!-- <span class="icon is-medium">
            <img src="../../static/img/measurements.svg" alt="measurements">
          </span> -->
        <!-- </div> -->
        <collapse is-fullwidth>
          <collapse-item v-if="ortophoto.length>0" v-bind:title="$t('leftPanel.ortophoto')">
            <ul>
              <li v-for="orto in ortophoto">
                <div class="layerCell">
                  <label class="panel-block">
                    <input type="checkbox" v-model="layersOn"  :value=orto.id>
                    <a v-on:click="zoomTo(orto.id)">{{ orto.name }}</a>
                  </label>
                  <span class="icon infoicon is-small">
                    <i class="fa fa-info-circle" aria-hidden="true" v-on:click="isVisible=!isVisible, showLayerInfoPanel(orto.id)"></i>
                  </span>
                </div>
              </li>
            </ul>
          </collapse-item>
          <collapse-item v-if="layers.length>0" v-bind:title="$t('leftPanel.layers')">
            <ul>
              <li v-for="layer in layers">
                <div class="layerCell">
                  <label class="panel-block">
                    <input type="checkbox" v-model="layersOn"  :value=layer.id>
                    <a v-on:click="zoomTo(layer.id)">{{ layer.name }}</a>
                  </label>
                  <span class="icon infoicon is-small">
                    <i class="fa fa-info-circle" aria-hidden="true" v-on:click="isVisible=!isVisible, showLayerInfoPanel(layer.id)"></i>
                  </span>
                </div>
              </li>
            </ul>
          </collapse-item>
          <collapse-item v-if="sensors.length>0" v-bind:title="$t('leftPanel.sensors')">
            <ul>
              <li v-for="sensor in sensors">
                <div class="layerCell">
                  <label class="panel-block">
                    <input type="checkbox" v-model="sensorsOn" @change="addSensorToMap" :value=sensor.id>
                    <a v-on:click="zoomTo(sensor.id)">{{ sensor.label }}</a>
                  </label>
                  <span class="icon infoicon is-small">
                    <i class="fa fa-info-circle" aria-hidden="true" v-on:click="isVisible=!isVisible, showLayerInfoPanel(sensor.id)"></i>
                  </span>
                </div>
              </li>
            </ul>
          </collapse-item>
            
          <collapse-item v-if="scenes.length>0" v-bind:title="$t('leftPanel.scenes')">
            <ul>
              <li v-for="scene in scenes">
                <div class="layerCell">
                  <label class="panel-block">
                    <a target="_blank" :href="scene.sceneUrl">{{scene.label}}</a>
                  </label>
                </div>
              </li>
            </ul>
          </collapse-item>

          <collapse-item v-if="markers.length>0" v-bind:title="$t('leftPanel.markers')">              
            <ul>
              <li v-for="(marker, index, key) in markers">
                <div class="markerCell">
                  <label class="panel-block">
                    <span class="icon is-small" v-on:click="mapOnClick(addMarkerToMap)">
                      <img src="../../static/img/marker.svg" alt="map-marker">
                    </span>
                    <a v-on:click="zoomTo(marker)">{{ $t('leftPanel.point') }} {{index}}</a>
                    <a class="button is-info" v-on:click="addNoteToMarker(marker)">{{ $t('leftPanel.note') }}</a>
                  </label>                    
                  <span class="icon removeMarkerIcon is-small">
                    <i class="fa fa-times-circle" aria-hidden="true" v-on:click="removeMarkerFromMap(marker)"></i>
                  </span>
                  <quill-editor v-model="noteContent[marker]" v-bind:class="marker" ref="myQuillEditor" :options="editorOption" @change="sendNote($event,marker)"></quill-editor>
                </div>
              </li>
            </ul>
          </collapse-item>
        </collapse>
      </nav>
    </div>

    <div class="columns pane">
      <div class="column is-2 layerInfoPanel" v-bind:class="{ visible: !isVisible }">
        <div class="upperPanel">
          <figure class="image is-138x138">
            <img :src="layerInfo.imgThumbnailUrl">
          </figure>
          <h1 class="title">{{ layerInfo.name }}</h1>
        </div>
        <ul class="lowerPanel">
          <li><strong>{{ $t('rightPanel.layer') }}: </strong> {{ layerInfo.name }}</li>
          <li><strong>{{ $t('rightPanel.project') }}: </strong> {{ layerInfo.projectName }}</li>
          <li><strong>{{ $t('rightPanel.date') }}: </strong> {{ layerInfo.timestamp }}</li>
        </ul>
        <a v-show="isDownLink" :href="downLink" class="downloadButton button is-primary">{{ $t('rightPanel.download') }}</a>
        <a v-show="isScene" target="_blank" :href="sceneUrl" class="downloadButton button is-info">{{ $t('rightPanel.scene') }}</a>
        <div class="togglePanel" v-on:click="isVisible=!isVisible">
          <span class="icon togglePanelIcon is-small">
            <i class="fa fa-angle-right" aria-hidden="true"></i>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* @flow */
import { Collapse, Item as CollapseItem } from 'vue-bulma-collapse'
import { HTTP } from '../common/http'
import { placeholders } from '../../static/localization/placeholders'
import L from 'leaflet'
import uuidv4 from 'uuid/v4'
import 'leaflet.gridlayer.googlemutant'
import 'leaflet.locatecontrol'
import Quill from 'quill'
import { quillEditor } from 'vue-quill-editor'
import $ from 'jquery'
import analytics from './Analytics'
import 'leaflet-geocoder-mapzen'
import { store } from '../store/index'

// BASEMAPS
const osm = L.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
  attribution: '&copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors',
  maxZoom: 22,
  continuousWorld: true
})
const mapycz = L.tileLayer('http://m{s}.mapserver.mapy.cz/wturist-m/{z}-{x}-{y}', {
  attribution: '<img src="http://mapy.cz/img/logo-small.svg" style="height: 10px" /> © <a href="//www.seznam.cz" target="_blank">Seznam.cz, a.s.</a>, © <a href="//www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>',
  subdomains: '1234',
  maxZoom: 22,
})

const cuzk = L.tileLayer.wms('http://geoportal.cuzk.cz/WMS_ORTOFOTO_PUB/WMService.aspx', {
  layers: 'GR_ORTFOTORGB',
  format: 'image/png',
  uppercase: true,
  transparent: true,
  continuousWorld: true,
  maxZoom: 22,
  opacity: 1.0
})

const google = {
  roads: L.gridLayer.googleMutant({
    type: 'roadmap' // valid values are 'roadmap', 'satellite', 'terrain' and 'hybrid'
  }),
  satellite: L.gridLayer.googleMutant({
    type: 'satellite' // valid values are 'roadmap', 'satellite', 'terrain' and 'hybrid'
  }),
  terrain: L.gridLayer.googleMutant({
    type: 'terrain' // valid values are 'roadmap', 'satellite', 'terrain' and 'hybrid'
  }),
  hybrid: L.gridLayer.googleMutant({
    type: 'hybrid' // valid values are 'roadmap', 'satellite', 'terrain' and 'hybrid'
  }),

}

const ndviSentinel = L.tileLayer.wms('https://services.sentinel-hub.com/v1/wms/0ae92d1c-ba38-4c88-bfe4-cf2f163d45ff?showLogo=false', {
  attribution: '&copy; <a href="http://www.sentinel-hub.com/" target="_blank">Sentinel Hub</a>',
  version: '1.3.0',
  layers: 'VEGETATION_INDEX',
  styles: '',
  format: 'image/jpeg',
  transparent: 'false',
  height: 512,
  width: 512,
  preview: '3',
  atmFilter: '',
  gain: '1',
  gamma: '1',
})


const baseMaps = {
  'OSM': osm,
  'Mapy.cz': mapycz,
  'ČUZK': cuzk,
  'Google Roads': google.roads,
  'Google Satellite': google.satellite,
  'Google Terrain': google.terrain,
  'Google Hybrid': google.hybrid,
  'Sentinel 2 NDVI': ndviSentinel
}

export default {
  name: 'leaflet',
  components: {
    quillEditor,
    analytics,
    Collapse,
    CollapseItem
  },
  data () {
    return {
      isActive: true,
      isVisible: true,
      showMarkerNote: true,
      showAnalytics: true,
      layers: [], // list of all layers id in project
      ortophoto: [], // list of all ortophoto layers
      allLayers: [],
      scenes: [],
      layersOn: [], // list of all switched on layers id
      sensorsOn: [],
      markers: [], // list of markers
      sensors: [], // list of sensors
      docs: [], // list of all documents - pdf,...
      previousLayerState: [],
      layerComposition: new L.layerGroup(),
      map: {},
      sensorGroup: {},
      layerInfo: {},
      markerIndex: 0,
      noteContent: [],
      editorOption: {
        theme: 'bubble',
        placeholder: placeholders.quill[this.$i18n.locale]
      },
      userId: JSON.parse(localStorage.getItem('credentials')).email,
      userName: JSON.parse(localStorage.getItem('profile')).name,
      wmsUrl: '',
      isDownLink: null,
      downLink: null,
      isScene: null,
      sceneUrl: null
    }
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor
    }
  },
  mounted () {
    this.$i18n.locale = JSON.parse(localStorage.getItem('profile')).lang
    const map = L.map('map', {
      center: JSON.parse(localStorage.getItem('profile')).defaultMapCenter,
      zoom: JSON.parse(localStorage.getItem('profile')).defaultMapZoom,
      layers: [ google.hybrid ],
      //crs:L.CRS.EPSG3857,
      zoomControl: false 
    })
    L.control.scale({
      metric: true,
      imperial: false,
      position: 'bottomright'
    }).addTo(map)
    L.control.zoom({ position: 'bottomright' }).addTo(map);
    L.control.geocoder('mapzen-7C2uFqf', {
      bounds: false,
      position: 'topright',
      placeholder: placeholders.geocoder[this.$i18n.locale],
      expanded: true,
      markers: false,
      layers: 'coarse',
      fullWidth: 650
    }).addTo(map)
    L.control.layers(baseMaps, null, { collapsed: true }).addTo(map)
    L.control.locate({
      position: 'bottomright',
      strings: {
        title: "",
        popup: ""
    }
    }).addTo(map)
    this.layerComposition.addTo(map)
    this.map = map
    this.getLayerList()
    const sensorGroup = L.layerGroup().addTo(this.map)
    this.sensorGroup = sensorGroup
  },
  methods: {
    onEditorChange({ editor, html, text }) {
      this.content = html
    },
    getLayerList: function () {
      // GETTING LIST OF LAYERS OF CURRENT USER AND CURRENT PROJECT
      HTTP.get('/layers/byProject/'+this.$route.params.projectId, {
        headers: {
        'token': localStorage.getItem('token'),
        'user': JSON.parse(localStorage.getItem('credentials')).email
      }
      }).then(response => {
        for (let i in response.data.data) {
          if(Reflect.has(response.data.data[i].meta, 'sceneUrl')) {
            this.scenes.push({
              label: response.data.data[i].meta.sceneName,
              sceneUrl: response.data.data[i].meta.sceneUrl
            })
            console.log(this.scenes);
          }
          if(response.data.data[i].meta)
          if (response.data.data[i].layerType === 'ortophoto'){
            this.ortophoto.push(response.data.data[i])
          } else {
            this.layers.push(response.data.data[i])
          }
        }
        this.allLayers = response.data.data
        store.commit('loadLayers', response.data.data)
      }).catch(error => {
        console.log('ERROR: ' + error)
      })
      // GETTING LIST OF MARKERS OF CURRENT USER AND CURRENT PROJECT
      HTTP.get('/layers/getMarkers/' + this.$route.params.projectId, {
        headers: {
        'token': localStorage.getItem('token'),
        'user': JSON.parse(localStorage.getItem('credentials')).email
      }
      }).then(response => {
        store.commit('loadMarkers', response.data)
        for(let i in response.data) {
            this.markers.push(response.data[i].leafletId)
            HTTP.get('/layers/getMarkerInfo/' + this.$route.params.projectId+ '/' + response.data[i].leafletId, {
              headers: {
                'token': localStorage.getItem('token'),
                'user': JSON.parse(localStorage.getItem('credentials')).email
              }
            }).then(response => {
              const Marker = new L.marker(response.data.latlng)
              Marker.id = response.data.leafletId
              Marker.bindPopup(response.data.note).openPopup()
              this.layerComposition.addLayer(Marker, true)
              for(let i in this.editor){
                if (this.editor[i].$el.classList[1] == response.data.leafletId) {
                  this.editor[i].value = response.data.note;
                }
              }
            }).catch(error => {
              console.log('ERROR: ' + error)
            })
        }
      }).catch(error => {
        console.log('ERROR: ' + error)
      })
      HTTP.get('/sensors/byUser/' + JSON.parse(localStorage.getItem('credentials')).email, {
        headers: {
          'token': localStorage.getItem('token'),
          'user': JSON.parse(localStorage.getItem('credentials')).email
        }
      }).then(response => {
        this.sensors = response.data.data
        store.commit('loadSensors', response.data.data)
      }).catch(error => {
          console.log('ERROR: ' + error)
      })
    },
    getLayerInfo: function (layerId) {
      for (let i in this.allLayers) {
        if (this.allLayers[i].id === layerId) {
          if (this.allLayers[i].layerType === 'ortophoto') {
          let layer = this.ortophoto.filter(layer => layer.id === layerId)
          return layer[0]
        } else {
          let layer = this.layers.filter(layer => layer.id === layerId)
          return layer[0]
        }
        }
      }
      for (let i in this.sensors) {
        if (this.sensors[i].id === layerId) {
          let layer = this.sensors.filter(layer => layer.id === layerId)
          return layer[0]
        }
      }
      
    },
    addLayerToMap: function (layer) {
      this.wmsUrl = layer.wmsUrl
      const tileLayer = L.tileLayer.wms(layer.wmsUrl, {
        layers: layer.wmsLayerName,
        format: layer.wmsFormat,
        zIndex: 99,
        maxZoom: layer.wmsMaxZoom,
        //crs:L.CRS.EPSG4326,
        transparent: layer.wmsTransparent,
        continuousWorld: true,
        id: layer.id,
        options: {
          centerPoint: layer.centerCoordinates
        }
      })
      this.layerComposition.addLayer(tileLayer, true)
    },
    addSensorToMap: function (e) {
      let selectedSensor = store.getters.getSensors.filter(sensor => sensor.id === e.srcElement.value)[0]
      let Sensor = new L.marker(selectedSensor.centerCoordinates)
      Sensor.id = selectedSensor.id
      Sensor.bindPopup(selectedSensor.popUpLabel).openPopup()
      if(this.sensorsOn.includes(e.srcElement.value)){
        Sensor.addTo(this.sensorGroup)
      } else {
        for(let i in this.sensorGroup.getLayers()) {
          if(this.sensorGroup.getLayers()[i].id === selectedSensor.id) {
            this.sensorGroup.removeLayer(this.sensorGroup.getLayers()[i]) 
          }
        }
      }
    },
    zoomTo: function(elId) {
      if(store.getters.getSensors.filter(sensor => sensor.id === elId).length > 0) {
        let sensor = store.getters.getSensors.filter(sensor => sensor.id === elId)[0]
        this.map.setView(sensor.centerCoordinates, 17)
      } else if (store.getters.getLayers.filter(layer => layer.id === elId).length > 0) {
        let layer = store.getters.getLayers.filter(layer => layer.id === elId)[0]
        this.map.setView(layer.centerCoordinates, 17)
      } else if (store.getters.getMarkers.filter(marker => marker.leafletId === elId)) {
        let marker = store.getters.getMarkers.filter(marker => marker.leafletId === elId)[0]
        console.log(elId);
        console.log(marker);
        this.map.setView(marker.latlng, 17)
      }
      
    },
    removeLayerFromMap: function (layer) {
      for (let i in this.layerComposition.getLayers()) {
        if (this.layerComposition.getLayers()[i].options.id === layer) {
          this.layerComposition.removeLayer(this.layerComposition.getLayers()[i])
          break
        }
      }
    },
    showLayerInfoPanel: function (layer) {
      this.layerInfo = {}
      HTTP.get('/layers/' + layer, {
        headers: {
        'token': localStorage.getItem('token'),
        'user': JSON.parse(localStorage.getItem('credentials')).email
      }
      }).then(response => {
        this.layerInfo = response.data.data[0]
        this.isDownLink = this.layerInfo.meta.hasOwnProperty('downLink')
        this.isScene = this.layerInfo.meta.hasOwnProperty('sceneUrl')
        this.downLink = this.isDownLink ? this.layerInfo.meta.downLink : null
        this.sceneUrl = this.isScene ? this.layerInfo.meta.sceneUrl : null
      }).catch(error => {
        console.log('ERROR: ' + error)
      })
    },
    addMarkerToMap: function (e) {
      const Marker = new L.marker(e.latlng)
      this.markerIndex++
      Marker.id = uuidv4()
      this.layerComposition.addLayer(Marker, true)
      store.commit('loadMarkers', {
        latlng: [Marker._latlng.lat, Marker._latlng.lng],
        leafletId: Marker.id,
        projectId: this.$route.params.projectId,
        note: ''
      })
      HTTP.post('/layers/addMarker', {
        latlng: [Marker._latlng.lat, Marker._latlng.lng],
        leafletId: Marker.id,
        projectId: this.$route.params.projectId,
        note: ''
      }, {
        headers: {
        'token': localStorage.getItem('token'),
        'user': JSON.parse(localStorage.getItem('credentials')).email
      }
      })
      .then()
      .catch( error => {
        console.log(error)
      })
      this.layerComposition.eachLayer(layer => {
        if (layer instanceof L.Marker) {
          if (this.markers.indexOf(layer.id) === -1) {
            this.markers.push(layer.id)
          }
        }
      })
    },
    removeMarkerFromMap: function (marker) {
      this.layerComposition.eachLayer(layer => {
        if(layer.id == marker) {
          this.map.removeLayer(layer)
          this.layerComposition.removeLayer(layer)
          this.markers.splice(this.markers.indexOf(marker),1)
          store.commit('removeMarkers', marker)
          HTTP.post('/layers/removeMarker', {
            leafletId: marker,
            projectId: this.$route.params.projectId
          }, {
            headers: {
              'token': localStorage.getItem('token'),
              'user': JSON.parse(localStorage.getItem('credentials')).email
            }
          })
          .then( response => {

          })
          .catch( error => {
            console.log(error)
          })
        }
      })
    },
    mapOnClick: function (callback) {
      this.map.on('click', callback)
    },
    addNoteToMarker: function (markerId) {
      $("." + markerId).toggle()
    },
    sendNote: function ({ editor, html, text }, markerId) {
      //$("." + markerId).hide()
      this.layerComposition.eachLayer(layer => {
        if (layer.id == markerId) {
          layer.bindPopup('<p>' + this.noteContent[markerId] + '</p>').openPopup()
          HTTP.post('/layers/editMarker', {
            leafletId: markerId,
            note: this.noteContent[markerId]
          }, {
            headers: {
              'token': localStorage.getItem('token'),
              'user': JSON.parse(localStorage.getItem('credentials')).email
            }
          })
            .then(response => {
            })
            .catch(error => {
              console.log(error)
            })
          
        }
      })
    },
    showHide: function() {
      if(!this.isActive && !this.showAnalytics) {
        this.showAnalytics = !this.showAnalytics
      }
    }
  },
  watch: {
    'layersOn': function () {
      if (this.previousLayerState.length > this.layersOn.length) {
        for (let j in this.previousLayerState) {
          if (!this.layersOn.includes(this.previousLayerState[j])) {
            this.removeLayerFromMap(this.previousLayerState[j])
            this.previousLayerState.splice(this.previousLayerState.indexOf(this.previousLayerState[j]), 1)
          }
        }
      } else {
        for (let i in this.layersOn) {
          if (!this.previousLayerState.includes(this.layersOn[i])) {
            this.addLayerToMap(this.getLayerInfo(this.layersOn[i]))
            this.previousLayerState.push(this.layersOn[i])
          }
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../static/style/leaflet.css";
@import '~leaflet-geocoder-mapzen/dist/leaflet-geocoder-mapzen.css';

.mapComponent{
  height: 100%;
}

a{
  color: #FFFFFF;
}
a:hover{
  color: #e2d9d9;
}
.map{
  height: calc(100% - 3.25rem);
  width: 100%;
}
.sidebar{
  display: inline-block;
  float: left;
}
.active{
  display: block !important;
}
.visible{
  display: block !important;
}
.show{
  display: block !important;
}
.panel{
  background: #00CBA9;
  opacity: 0.9;
  z-index: 1000;
  position: absolute;
  height: calc(100% - 3.25rem);
  width: 4rem;
  top: 0px;
  margin-bottom: 0px;
  overflow: auto;
}
.panel-heading{
  background-color: #00CBA9;
  border-left: none;
  border-right: none;
  border-bottom: 1px solid #007C67;
  color: #FFFFFF;
}
.panel-block{
  border-left: none;
  border-right: none;
  border-bottom: none;
  margin-top: 4px;
  margin-bottom: 4px;
  border-top: none;
  color: #FFFFFF;
  font-size: 0px;
  width: 92%;
  display: -webkit-inline-box;
}
.panel-block input[type="checkbox"] {
  margin-right: 0.5em;
  font-size: 16px;
}
.is-active{
  border-bottom: none !important;
}
a.panel-block:hover, label.panel-block:hover{
  background-color: rgba(255,255,255,.1);
}
.mainpanel{
  display: none;
  top: 3.25rem;
}
.layerpanel{
  display: none;
  width: 15rem;
  top: 3.25rem;
  overflow-x: hidden;
  -webkit-animation: layerPanelMove 0.3s ease;
}
@keyframes layerPanelMove
  {
    0% {
      left: -100%;
    }
    100% {
      left: 0%;;
    }
}
.panel-heading{
  text-transform: uppercase;
}
label.panel-block:hover{
  background: transparent;
}
.layerCell{
  border-bottom: 1px solid #007c67;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 5px;
  text-align: left;
}
.layerCell:hover{
  background: rgba(255, 255, 255, 0.1)
}
.layerCell a{
  font-size: 15px;
}
.markerCell{
  border-bottom: 1px solid #007c67;
  /*width: 100%;*/
}
.markerCell label{
  width: 92%;
}
.markerCell .button{
  height: 1.25rem;
  left: 15%;
}
.collapse .card{
  background-color: #00CBA9;
  border-bottom: 1px solid #00A186;
  box-shadow: none;
}
.quill-editor{
  display: none;
  background: white;
  left: 101%;
  width: 12rem;
  height: 9rem;
  margin: 0 auto;
}

.showMarkerNote {
  display: block;
}

.tools{
  height: 40px;
  border-bottom: 1px solid #007C67;
}
.tools span{
  float: left;
  height: 100%;
  padding: 0px 5px 0px 5px;
}
.menuicon{
  border-bottom: 0.5px #007C67 solid;
  color: #FFFFFF;
  width: 100%;
  height: 50px;
}
.charticon{
  position: relative;
  top: -6px;
}
.closeicon{
  position: relative;
  float: right;
  top: 4px;
  color: #000000;
}
.icon:hover{
  cursor: pointer;
  background: rgba(255,255,255,.1);
}
.infoicon{
  display: inline-block;
  width: 8%;
  float: right;
  position: relative;
  top: 8px;
  color: #FFFFFF;
}
.infoicon:hover{
  background: none;
}
.removeMarkerIcon{
  display: inline-block;
  width: 8%;
  float: right;
  position: relative;
  top: 9px;
  color: #FFFFFF;
}
.layerLabel{
  width: 80%;
  display: inline-table;
}
.layers{
  background-image: url('../../static/img/layers.svg');
  height: 100%;
  width: 100%;
  background-size: 28px;
  background-repeat: no-repeat;
  background-position: center;
}
.pane{
  display: inline-block;
}
.layerInfoPanel{
  position: absolute;
  height: 100%;
  right: 0px;
  top: 3.25rem;
  background: #FFFFFF;
  z-index: 1000;
  display: none;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;

}
.upperPanel{
  position: relative;
  height: auto;
  text-align: center;
  width: 100%;
  padding-top: 10px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
}
.upperPanel img{
  height: 250px;
  width: auto;
  display: initial;
}
.upperPanel h1{
  font-size: 20px;
  text-transform: uppercase;
  color: #FFFFFF;
  margin-top: 15px;
}
.upperPanel figure{
  margin: auto;
}
.lowerPanel{
  position: relative;
  height: auto;
  padding-top: 30px;
  margin: 10px;
}
.lowerPanel li {
  padding-top: 5px;
  padding-bottom: 5px;
}
.lowerPanel p{
  float: left;
  padding-bottom: 5px;
  text-align: left;
}
.lowerPanel strong{
  float: left;
  margin-right: 5px;
}
.downloadButton{
  margin: 10px;
}
.togglePanel{
  top: 20px;
  position: absolute;
  left: -22px;
  background: #FFFFFF;
  height: 35px;
  width: 22px;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
  border-left: 1px solid #D4D4D4;
}
.toggleLayerPanel{
  height: 40px;
  width: 100%;
  cursor: pointer;
  border-bottom: 1px solid #007C67;
}
.toggleLayerPanel i{
  padding: 0.75rem;
}
.toggleLayerPanel p {
  display: inline-block;
  position: relative;
  top: 12px;
  right: 10px;
}
.togglePanelIcon{
  vertical-align: -webkit-baseline-middle;
}
.navbar {
  background: #269885;
  border-bottom: 1px solid #82a6d2;
  z-index: 9999;
}

a.navbar-item:hover,
a.navbar-item.is-active,
.navbar-link:hover,
.navbar-link.is-active {
  background-color: rgba(255,255,255,.1);
}

.navbar-brand a:hover {
  background: none;
  cursor: auto;
}

.navbar-item,
.navbar-link {
  color: #FFFFFF;
  padding: 0rem 1rem;
  text-transform: uppercase;
}

.navbar-item img {
  max-height: 2.75rem;
}

.navbar-dropdown {
  border-radius: 0px;
}

.projects {
  position: absolute;
  width: 100%;
  margin: 50px;
}

.projects li {
  width: 265px;
}

.logout {
  color: #000000;
}

.navbar-brand .navbar-item{
  padding-left: 12px;
}
.navbar-dropdown .logout:hover {
  background: none;
}

.userProfile {
  padding-right: 0px;
  padding-left: 0px;
}

.userProfile .navbar-link {
  border-left: 0.5px solid #666e82;
}
.navbar-item.has-dropdown:hover .navbar-link,
.navbar-item.has-dropdown.is-active .navbar-link {
  background: none;
}
.userProfile .navbar-link::after {
  border: none;
}
.userProfile .navbar-link:hover {
  background: #018083;
}
.userProfile .navbar-dropdown {
  left: auto;
}
.user {
  width: auto;
  color: #FFFFFF !important;
  font-size: 16px;
}
.user i {
  padding-left: 20px;
  color: #000000;
}
.icon.is-medium .fa {
  font-size: 28px;
}
.icon.is-small .fa {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// Map.vue?c2826542